import { Link, useSearchParams } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const ref = params.get("ref");
  return (
    <div className="min-h-screen bg-[#050505]" data-testid="payment-cancel-page">
      <Header />
      <div className="pt-40 pb-20 max-w-3xl mx-auto px-6 lg:px-10 text-center">
        <XCircle className="mx-auto text-red-400" size={64} />
        <h1 className="mt-6 font-serif text-white text-4xl">Paiement annulé</h1>
        <p className="mt-3 text-gray-400">
          Votre réservation {ref && <b className="gold">{ref}</b>} n'a pas été
          finalisée. Vous pouvez réessayer à tout moment.
        </p>
        <div className="mt-8 flex gap-4 justify-center">
          <Link to="/" className="btn-outline-gold">Retour à l'accueil</Link>
          <Link to="/convoyage" className="btn-gold">Nouvelle demande</Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
